import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ClassicButtonBlockConfig } from '@front-platform/content-builder';
import { classicButtonBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface ClassicButtonBlockRuntimeConfig {
  'on_site_location_id'?: string;
  'thick_size'?: 'S' | 'M' | 'L';
}

export type ClassicButtonBlockConfigInput = Partial<
  Omit<ClassicButtonBlockConfig, keyof ClassicButtonBlockRuntimeConfig> &
    ClassicButtonBlockRuntimeConfig
>;
export type ClassicButtonBlockResolvedConfig = Omit<
  ClassicButtonBlockConfig,
  keyof ClassicButtonBlockRuntimeConfig
> &
  Partial<ClassicButtonBlockRuntimeConfig>;
export interface ClassicButtonBlockContract extends ConfigComponentContract<
  ClassicButtonBlockConfigInput,
  ClassicButtonBlockResolvedConfig
> {}

@Component({
  selector: 'app-classic-button-block',
  templateUrl: './classic-button-block.component.html',
  standalone: false,
})
export class ClassicButtonBlockComponent implements ClassicButtonBlockContract {
  readonly config = input<ClassicButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ClassicButtonBlockConfig,
    ClassicButtonBlockRuntimeConfig
  >(classicButtonBlockResolveConfig, () => ({ config: this.config() }));
  get url(): string {
    return this.resolvedConfig()['url'] as unknown as string;
  }
  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get onSiteLocationId(): string {
    return this.resolvedConfig()['on_site_location_id'] as unknown as string;
  }
  get thickSize(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['thick_size'] as unknown as 'S' | 'M' | 'L';
  }
  get type(): 'primary' | 'light' | 'outlined' {
    return this.resolvedConfig()['type'] as unknown as 'primary' | 'light' | 'outlined';
  }
  get color(): 'neutral' | 'success' | 'primary' | 'info' | 'highligh' {
    return this.resolvedConfig()['color'] as unknown as
      'neutral' | 'success' | 'primary' | 'info' | 'highligh';
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ClassicButtonBlockComponent, { 'keyAliases': {} });
